module.exports = __webpack_public_path__ + "media/svg/company_light_horizontal-d46ba048.svg";